export default __webpack_public_path__ + "static/media/croptop-large-right-toobig.9ceb2411.jpg";